/// <reference path="../typings.d.ts" />
import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTitle } from './title';
import { OneRosterService } from './oneroster.service';
import { Alert } from './alert';
import { SftpRegistration } from './sftp_registration';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { controlErrors } from './app.validators';
import { SchoolAccount } from './school_account';

@Component({
	selector: 'sftp-add',
	template: `
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-12 col-md-12 col-xs-12" style="padding-left:0px;">
                <form [formGroup]="form" novalid>
                    <div class="row">
                        <!-- SFTP Client Configuration -->
                        <div class="col-lg-6 col-md-6 col-xs-12" style="margin-bottom:0px;">
                            <h4>SFTP Client Settings</h4>
                            <div class="form-group">
                                <p class="custom-label">Host</p>
                                <input type="text" formControlName="host" class="form-control" [readonly]="isHostedServer" [placeholder]="isHostedServer && !editMode ? 'Assigned automatically' : 'sftp.example.com'">
                            </div>
                            <div class="form-group">
                                <p class="custom-label">Port</p>
                                <input type="number" formControlName="port" class="form-control" [readonly]="isHostedServer" placeholder="22">
                            </div>
                            <div class="form-group">
                                <p class="custom-label">Username</p>
                                <div [class.input-group]="isHostedServer">
                                    <input type="text" formControlName="username" class="form-control" [readonly]="isHostedServer">
                                    <span class="input-group-btn" *ngIf="isHostedServer">
                                        <button class="btn btn-default" type="button" (click)="copyUsername()" title="Copy username">
                                            <span class="glyphicon glyphicon-copy"></span>
                                        </button>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <p class="custom-label">Password</p>
                                <div class="input-group">
                                    <input [type]="showPassword ? 'text' : 'password'" formControlName="password" class="form-control" [readonly]="isHostedServer">
                                    <span class="input-group-btn">
                                        <button class="btn btn-default" type="button" (click)="showPassword = !showPassword" [title]="showPassword ? 'Hide password' : 'Show password'">
                                            <span class="glyphicon" [ngClass]="showPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'"></span>
                                        </button>
                                        <button *ngIf="isHostedServer" class="btn btn-default" type="button" (click)="copyPassword()" title="Copy password">
                                            <span class="glyphicon glyphicon-copy"></span>
                                        </button>
                                    </span>
                                </div>
                            </div>
                            <div *ngIf="isHostedServer && !editMode" style="margin-top: 10px; margin-bottom: 15px;">
                                <button type="button" class="btn btn-default btn-sm" (click)="regenerateCredentials()">
                                    <span class="glyphicon glyphicon-refresh"></span> Regenerate Credentials
                                </button>
                            </div>
                        </div>

                        <!-- SFTP File Configuration -->
                        <div class="col-lg-6 col-md-6 col-xs-12">
                            <h4>File Settings</h4>
                            <div class="form-group" *ngIf="!isHostedServer">
                                <p class="custom-label">Remote Path</p>
                                <input type="text" formControlName="remotePath" class="form-control" placeholder="/outbox">
                            </div>
                            <div class="form-group">
                                <p class="custom-label">File Pattern</p>
                                <input type="text" formControlName="fileNamePattern" class="form-control" placeholder="*.csv">
                            </div>

                            <!-- CSV Mapper inside File Settings for Hosted SFTP Server mode -->
                            <div class="form-group" *ngIf="isHostedServer" style="margin-top: 15px;">
                                <p class="custom-label">
                                    <a style="cursor: pointer; font-size: 13px;" (click)="showCsvMapper = !showCsvMapper">
                                        {{ showCsvMapper ? 'Hide' : 'Show' }} CSV Mapper
                                    </a>
                                </p>
                                <div [hidden]="!showCsvMapper">
                                    <textarea formControlName="csvMappingJson" class="form-control" style="height: 195px; resize: vertical;" placeholder='{ "csvMappingConfigs": [...] }'></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- CSV Mapper in bottom row for Default / External mode -->
                    <div class="row" *ngIf="!isHostedServer">
                        <div class="col-lg-12 col-md-12 col-xs-12" style="margin-bottom:0px;">
                            <h4>
                                <a style="cursor: pointer; font-size: 14px;" (click)="showCsvMapper = !showCsvMapper">
                                    {{ showCsvMapper ? 'Hide' : 'Show' }} CSV Mapper
                                </a>
                            </h4>
                            <div class="form-group" [hidden]="!showCsvMapper">
                                <textarea formControlName="csvMappingJson" class="form-control" rows="10" placeholder='{ "csvMappingConfigs": [...] }'></textarea>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
                <button *ngIf="!isHostedServer" style="margin-left:10px;" type="button" class="btn btn-large btn-deny" (click)="testConnection()">Test Connection</button>
                <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>
	    </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
    `
})
export class SftpAddComponent implements OnInit {
	msg: Alert;
	msgHead: Alert;
	acctNumber: string;
	idParam: string;
	editMode: boolean;
	hasAccess: boolean;
	form: FormGroup;
	schools: SchoolAccount[] = [];
	data: SftpRegistration;
	saveCount: number;
	showCsvMapper: boolean = false;
	isHostedServer: boolean = false;
	showPassword: boolean = false;

	constructor(
		private router: Router,
		private orvc: OneRosterService,
		private fb: FormBuilder,
		private title: AppTitle,
		private activatedRoute: ActivatedRoute
	) {
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		this.editMode = false;

		this.form = this.fb.group({
			host: ['', Validators.required],
			port: [22, Validators.required],
			username: ['', Validators.required],
			password: ['', Validators.required],
			remotePath: ['', Validators.required],
			fileNamePattern: ['*.csv'],
			csvMappingJson: ['']
		});
		this.saveCount = 1;

		this.data = new SftpRegistration();
	}

	ngOnInit() {
		this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
		this.idParam = this.activatedRoute.snapshot.params['id'];

		let titleStr = 'Connect';
		if (this.idParam) {
			this.editMode = true;
			this.loadData();
			titleStr = 'Edit';
		} else {
			const mode = this.activatedRoute.snapshot.queryParams['mode'];
			if (mode === 'hosted') {
				this.enableHostedMode();
				titleStr = 'Create Hosted';
			} else {
				this.enableExternalMode();
			}
		}

		this.title.setTitles({ title: `${titleStr} SFTP Configuration`, dashboard: 'SFTP' });
		this.title.setBreadcrumbs([
			{ title: 'SFTP', link: `settings/${this.acctNumber}/sftp` },
			{ title: titleStr, link: `` }
		]);
	}

	loadData() {
		this.orvc.sftpRegistrationFindApi(this.acctNumber, { id: parseInt(this.idParam) })
			.subscribe(res => {
				if (res && res.length > 0) {
					this.data = res[0];
					this.isHostedServer = !!this.data.isHostedServer;
					this.updateHostedValidation();

					if (this.data.sftpConfig && this.data.sftpConfig.client) {
						this.form.get('host').setValue(this.data.sftpConfig.client.host || '');
						this.form.get('port').setValue(this.data.sftpConfig.client.port);
						this.form.get('username').setValue(this.data.sftpConfig.client.username);
						this.form.get('password').setValue(this.data.sftpConfig.client.password);
					}
					if (this.data.sftpConfig && this.data.sftpConfig.file) {
						this.form.get('remotePath').setValue(this.data.sftpConfig.file.remotePath);
						this.form.get('fileNamePattern').setValue(this.data.sftpConfig.file.fileNamePattern);
					}
					if (this.data.csvMapping) {
						this.form.get('csvMappingJson').setValue(JSON.stringify(this.data.csvMapping, null, 4));
					}
				}
			});
	}

	enableHostedMode() {
		this.isHostedServer = true;
		this.updateHostedValidation();
		this.form.get('remotePath').setValue('/');
		this.showPassword = false;

		this.regenerateCredentials();
	}

	regenerateCredentials() {
		this.orvc.sftpGenerateCredentialsApi(this.acctNumber)
			.subscribe(creds => {
				this.form.get('host').setValue(creds.host || '');
				this.form.get('port').setValue(creds.port || 7000);
				this.form.get('username').setValue(creds.username);
				this.form.get('password').setValue(creds.password);
			}, err => {
				this.msg.error(this.orvc.getUserErrorDefault(err));
			});
	}

	enableExternalMode() {
		this.isHostedServer = false;
		this.updateHostedValidation();

		this.form.get('host').setValue('');
		this.form.get('port').setValue(22);
		this.form.get('username').setValue('');
		this.form.get('password').setValue('');
		this.form.get('remotePath').setValue('');
		this.showPassword = false;
	}

	copyUsername() {
		const username = this.form.get('username').value;
		if (username) {
			this.copyToClipboard(username, 'Username copied to clipboard!');
		}
	}

	copyPassword() {
		const pwd = this.form.get('password').value;
		if (pwd) {
			this.copyToClipboard(pwd, 'Password copied to clipboard!');
		}
	}

	copyToClipboard(text: string, successMsg: string) {
		const nav: any = navigator;
		if (nav && nav.clipboard && nav.clipboard.writeText) {
			nav.clipboard.writeText(text).then(() => {
				this.msg.success(successMsg);
			}).catch(() => {
				this.copyFallback(text, successMsg);
			});
		} else {
			this.copyFallback(text, successMsg);
		}
	}

	copyFallback(text: string, successMsg: string) {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.position = 'fixed';
		textArea.style.top = '0';
		textArea.style.left = '0';
		textArea.style.opacity = '0';
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();
		try {
			document.execCommand('copy');
			this.msg.success(successMsg);
		} catch (e) {
			this.msg.error('Could not copy to clipboard');
		}
		document.body.removeChild(textArea);
	}

	updateHostedValidation() {
		const hostControl = this.form.get('host');
		const remotePathControl = this.form.get('remotePath');

		if (this.isHostedServer) {
			if (!this.editMode) {
				hostControl.clearValidators();
			} else {
				hostControl.setValidators([Validators.required]);
			}
			remotePathControl.clearValidators();
			if (!remotePathControl.value) {
				remotePathControl.setValue('/');
			}
		} else {
			hostControl.setValidators([Validators.required]);
			remotePathControl.setValidators([Validators.required]);
		}

		hostControl.updateValueAndValidity();
		remotePathControl.updateValueAndValidity();
	}

	viewToRequest(r: SftpRegistration): SftpRegistration {
		let ret = new SftpRegistration();
		ret.id = r.id;
		ret.syncEnabled = true;
		ret.isHostedServer = this.isHostedServer;
		ret.sftpConfig = {
			client: {
				host: this.form.get('host').value,
				port: parseInt(this.form.get('port').value),
				username: this.form.get('username').value,
				password: this.form.get('password').value
			},
			file: {
				remotePath: this.isHostedServer ? '/' : this.form.get('remotePath').value,
				fileNamePattern: this.form.get('fileNamePattern').value
			}
		};
		ret.csvMapping = JSON.parse(this.form.get('csvMappingJson').value || 'null');
		return ret;
	}

	displayErrors(f: FormGroup) {
		var message = '';
		controlErrors(f, (c: any, err: any) => {
			message += err + '<br>';
		});
		this.msg.errorHtml(message);
	}

	testConnection() {
		this.msg.info("Testing connection...");
		let req = this.viewToRequest(this.data);
		this.orvc.sftpTestConnectionApi(this.acctNumber, req)
			.subscribe(dirs => {
				if (dirs && dirs.length > 0) {
					this.msg.successHtml("Connection Successful!<br>Entries:<br>" + dirs.join("<br>"));
				} else {
					this.msg.success("Connection Successful! (No files found)");
				}
			}, err => {
				this.msg.error(err.message);
			});
	}

	save() {
		if (!this.form.valid) {
			this.displayErrors(this.form);
			return;
		}

		let req = this.viewToRequest(this.data);

		if (this.editMode) {
			this.orvc.sftpRegistrationUpdateApi(this.acctNumber, req)
				.subscribe(res => {
					let saveMessage = this.orvc.getDefaultSaveMessage();
					if (this.saveCount > 1) {
						saveMessage += ` (${this.saveCount})`
					}
					this.saveCount++;
					this.msg.success(saveMessage);
				}, err => {
					this.msg.error(this.orvc.getUserErrorDefault(err));
				});
		} else {
			this.orvc.sftpRegistrationAddApi(this.acctNumber, req)
				.subscribe(res => {
					let saveMessage = this.orvc.getDefaultSaveMessage();
					if (this.saveCount > 1) {
						saveMessage += ` (${this.saveCount})`
					}
					this.saveCount++;
					this.msg.success(saveMessage);
				}, err => {
					this.msg.error(this.orvc.getUserErrorDefault(err));
				});
		}
	}

	goBack() {
		this.router.navigate([`settings/${this.acctNumber}/sftp`]);
	}
}
